import React from 'react';
import styled from 'styled-components';
import { Container, Heading, Text } from '../styles/components';
import VideoLightbox from './VideoLightbox';

const SectionWrapper = styled.section`
  padding: ${props => props.theme.spacing.xxl} 0;
`;

const ContentCard = styled.div`
  background-color: ${props => props.theme.colors.text};
  border-radius: ${props => props.theme.radii.card};
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
  padding: ${props => props.theme.spacing.xxl} 0;
  margin-top: ${props => props.theme.spacing.xxl};
`;

const ContentInner = styled.div`
  max-width: ${props => props.theme.spacing.maxWidth};
  margin: 0 auto;
  padding: 0 ${props => props.theme.spacing.containerPadding};
`;

const StrategyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${props => props.theme.spacing.xl};
  margin: ${props => props.theme.spacing.xxl} 0;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: repeat(2, 1fr);
    gap: ${props => props.theme.spacing.lg};
  }

  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

const StrategyItem = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  text-align: center;
  width: 100%;
  transition: transform ${props => props.theme.transitions.default};

  &:hover {
    transform: translateY(-4px);
  }
`;

const IconWrapper = styled.div`
  background: ${props => props.theme.colors.moogulbg};
  border-radius: 100vh;  // This ensures a perfect circle
  width: 8rem;
  height: 8rem;
  margin-bottom: ${props => props.theme.spacing.md};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  margin-right: auto;

  img {
    width: 8rem;
    height: 8rem;
    object-fit: contain;
  }
`;

const StrategyLabel = styled(Text)`
  margin: 0;
  font-weight: 500;
  color: ${props => props.theme.colors.background};
`;

const StyledHeading = styled(Heading)`
  color: ${props => props.theme.colors.background};
`;

const strategyItems = [
  { 
    id: 'audience', 
    label: 'Audience analysis', 
    icon: '/assets/strategy/audience-icon.webp',
    videoUrl: 'https://customer-sjqbfslkojr1yxj1.cloudflarestream.com/c71b0c4ee97c6869e661627e9182480b/manifest/video.m3u8',
  },
  { id: 'offer', label: 'Offer strategy', icon: '/assets/strategy/offer-icon.webp' },
  { id: 'tone', label: 'Tone of voice', icon: '/assets/strategy/tone-icon.webp' },
  { id: 'ip', label: 'IP / methodologies', icon: '/assets/strategy/ip-icon.webp' },
  { id: 'platforms', label: 'Content platforms', icon: '/assets/strategy/platforms-icon.webp' },
  { id: 'proof', label: 'Brand proof', icon: '/assets/strategy/proof-icon.webp' },
  { id: 'knowledge', label: 'Knowledge', icon: '/assets/strategy/knowledge-icon.webp' },
  { id: 'vision', label: 'Vision & Values', icon: '/assets/strategy/vision-icon.webp' },
];

const StrategySection = () => {
  const [lightboxOpen, setLightboxOpen] = React.useState(false);
  const [currentVideo, setCurrentVideo] = React.useState(null);

  const handleItemClick = (item) => {
    setCurrentVideo(item);
    setLightboxOpen(true);
  };

  return (
    <SectionWrapper>
      <ContentCard>
        <ContentInner>
          <StyledHeading as="h2" $align="center">
            Finally! A home for all your poor, unloved strategy...
          </StyledHeading>
          
          <StrategyGrid>
            {strategyItems.map(item => (
              <StrategyItem 
                key={item.id}
                onClick={() => handleItemClick(item)}
              >
                <IconWrapper>
                  <img src={item.icon} alt={item.label} />
                </IconWrapper>
                <StrategyLabel>{item.label}</StrategyLabel>
              </StrategyItem>
            ))}
          </StrategyGrid>

          <StyledHeading as="h3" $align="center" size="h4">
            ...so it can work harder & smarter - while you work less
          </StyledHeading>
        </ContentInner>
      </ContentCard>
      
      <VideoLightbox
        isOpen={lightboxOpen}
        onClose={() => setLightboxOpen(false)}
        currentVideo={currentVideo}
        videos={strategyItems}
        onVideoSelect={setCurrentVideo}
      />
    </SectionWrapper>
  );
};

export default StrategySection; 